/**
 * Display a toaster notification.
 * @param {Object} options - Options for the toaster notification
 * @param {string} options.msg - Message to display in the toaster
 * @param {'s' | 'e' | 'i' | 'w'} [options.eType='s'] - Type of toaster notification ('s' for success, 'e' for error, 'i' for info, 'w' for warning)
 */

export const showToaster = ({ msg, eType = 's' }) => {
  if (typeof window === 'undefined') return
  const event = new CustomEvent('toasterEvent', {
    bubbles: true,
    detail: { msg, eType }
  })
  document.dispatchEvent(event)
}
